import jq from 'jquery';
import { usernameSuggester } from '@shared/username-suggester';
import 'jquery-validate';
import 'mailcheck';
import { T_ } from '@shared/translation';
import { sslBaseUrl } from 'server-data/flconfigs';
import { getCSRFToken } from '@shared/cookie';
import { isBlockedEmail } from '@shared/utility-functions';

const usernamePattern = /^[a-z][a-z0-9]{2,15}$/i;
const usernameMin = 3;
const usernameMax = 16;
let isUserReturned = false;
let loginAjax = false;
let loginCallback = false;
let domClass = {
  authFormAlert: '.auth-form-alert',
  authFormError: '.auth-form-error',
  formStep: 'control-group',
  formStepSelector: '.control-group',
  success: 'success',
  successSelector: '.success',
  error: 'error',
  errorSelector: '.error',
  warning: 'warning',
  warningSelector: '.warning',
  formError: 'help-inline',
  formErrorSelector: '.help-inline',
  formHelp: 'help-inline',
  formHelpSelector: '.help-inline',
};

let signupModalRequired;
let previousEmailValidated;

const isPPP = window.isPPP;

function init(params) {
  signupModalRequired = params.signupModalRequired;

  jq(document).ready(() => {
    // Auth window
    jq('.authTypeBtn').click(function() {
      jq(this)
        .siblings('.authTypeBtn')
        .find('input')
        .attr('checked', false);
      jq(this)
        .find('input')
        .attr('checked', true);
      jq('.authTypeBtn').removeClass('bold');
      jq(this).addClass('bold');

      if (
        jq(this)
          .find('input')
          .val() == 'userTypeNew'
      ) {
        jq('#userTypeReturningDiv').hide();
        jq('#projectLoginUserCreate').show();
      } else {
        jq('#projectLoginUserCreate').hide();
        jq('#userTypeReturningDiv').show();
      }

      // Clear Authform Errors
      clearAuthFormMessages();
    });

    // Occurs only in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      jq('#nonAuthForm').on('click', '#loginLinkPrefill', () => {
        showPrefilledLoginForm();
      });
    }

    jq('#nonAuthForm input').focus(event => {
      const element = event.currentTarget;
      const controlGroupDom = jq(element).closest(domClass.formStepSelector);
      // Occurs only in PPP
      if (controlGroupDom.length > 0) {
        if (typeof isPPP !== 'undefined' && isPPP) {
          controlGroupDom
            .removeClass(
              `${domClass.successSelector} ` +
                `${domClass.errorSelector} ${domClass.error} ` +
                'is-warning',
            )
            .find(domClass.formErrorText)
            .html('');
        } else {
          controlGroupDom
            .removeClass(
              `${domClass.successSelector} ${domClass.errorSelector}`,
            )
            .find(domClass.formErrorSelector)
            .html('');
        }
      }
    });

    // Occurs only in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      jq('#nonAuthForm').on('keyup', '#passwd', event => {
        if (!jq('.password-suggestion-widget').hasClass('hide')) {
          const element = event.target;
          if (jq(element).valid()) {
            const controlGroupDom = jq(element).closest(
              domClass.formStepSelector,
            );
            controlGroupDom
              .removeClass(
                `${domClass.successSelector} ` +
                  `${domClass.errorSelector} is-warning`,
              )
              .find(domClass.formErrorText)
              .html('');
          }
          if (jq(element).val() === '') {
            updatePasswordHelp({}, false);
          }
        }
      });
    }

    const validateRules = {
      // Returning user
      username: {
        required: '#userTypeReturning:checked',
      },
      passwd: {
        required: '#userTypeReturning:checked',
        verifyUser: true,
      },

      // New User
      newusername: {
        required: '#userTypeNew:checked',
        rangelength: [usernameMin, usernameMax],
        checkNewUsernamePattern: true,
      },
      email: {
        required: '#userTypeNew:checked',
        email: true,
      },
      newuserpasswd: {
        required: '#userTypeNew:checked',
        usernamePasswordEqualCheck: '#new-username',
        checkPasswordPattern: true,
      },
      newuserpasswd1: {
        required: '#userTypeNew:checked',
        equalTo: '#nonAuthForm #passwd',
      },
    };

    // Only occurs in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      validateRules.newuserpasswd1 = {
        required: '#userTypeNew:checked #passwd',
        equalTo: '#nonAuthForm #passwd',
      };
    }

    if (typeof params === 'object') {
      if (params.noConfirmPassword) {
        delete validateRules.newuserpasswd1;
      }
      if (params.useFLStyle) {
        domClass = {
          authFormAlert: '.auth-form-alert',
          authFormError: '.auth-form-error',
          formStep: 'form-step',
          formStepSelector: '.form-step',
          success: 'is-valid',
          successSelector: '.is-valid',
          error: 'is-invalid',
          warningOrange: 'is-warning',
          errorSelector: '.is-invalid',
          warning: 'is-help',
          warningSelector: '.is-help',
          formError: 'form-error',
          formErrorSelector: '.form-error',
          formErrorText: '.error-text',
          formHelp: 'form-help',
          formHelpSelector: '.form-help',
        };
      }

      if (params.isReturningUser) {
        jq('#userTypeReturning').attr('checked', 'true');
        jq('#userTypeReturningDiv').show();
        jq('#projectLoginUserCreate').hide();
      }

      if (params.trackNewEmail) {
        jq('#new-email').on('emailValid', function() {
          const previousEmailBuffer =
            typeof previousEmailValidated === 'object'
              ? previousEmailValidated
              : [];

          const validNewEmail = jq(this).val();

          if (previousEmailBuffer.indexOf(validNewEmail) === -1) {
            _lt.push([
              'emails_captured',
              {
                email: validNewEmail,
              },
            ]);

            previousEmailBuffer.push(validNewEmail);
          }

          previousEmailValidated = previousEmailBuffer;
        });
      }

      if (typeof params.loginCallback === 'function') {
        loginCallback = params.loginCallback;
      }
    }

    const form = jq('#nonAuthForm');
    form.on('submit', e => {
      e.preventDefault();
    });

    form.validate({
      errorElement: 'span',
      onsubmit: false,
      onkeyup: false,
      onfocusout(element) {
        // Only occurs in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq(element)
            .parent('li')
            .removeClass(
              `${domClass.error} ` +
                `${domClass.warningOrange} ` +
                `${domClass.success}`,
            );
          if (jq(element).val() === '') {
            if (
              jq(element).attr('id') === 'passwd1' &&
              jq('#passwd').val() !== ''
            ) {
              jq(element).valid();
            }
            return;
          }
          // Only trigger the authentication if the password is not empty.
        } else if (
          element.id === 'post-proj-username' &&
          jq('#post-proj-pwd').val() === ''
        ) {
          return;
        }
        // End of AB Test
        // Validate first the patterns before submitting it to the server.
        if (jq(element).valid()) {
          if (element.id === 'new-username') {
            verifyNewUsername();
          } else if (element.id === 'new-email') {
            verifyNewEmail();
          }
        }
      },
      errorPlacement(error, element) {
        // AB Test UX Improvements 2
        if (typeof isPPP !== 'undefined' && isPPP) {
          const errorText = element
            .siblings(domClass.formErrorSelector)
            .find(domClass.formErrorText);
          error.appendTo(errorText);
        } else {
          error.appendTo(element.siblings(domClass.formErrorSelector));
        }
        // End of AB Test
      },
      rules: validateRules,
      messages: {
        newusername: {
          rangelength: T_('Username must be 3-16 characters.'),
        },
        newuserpasswd: {
          rangelength: T_('Password must be 6-16 characters.'),
        },
      },

      highlight(label) {
        const controlGroupDom = jq(label).closest(domClass.formStepSelector);
        controlGroupDom.removeClass(domClass.success);
        // Only occurs in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          controlGroupDom.addClass(domClass.warningOrange);
        } else {
          controlGroupDom.addClass(domClass.error);
        }
      },

      unhighlight(element, errorClass) {
        if (element.type === 'radio') {
          this.findByName(element.name).removeClass(
            `${errorClass} ${domClass.warningOrange}`,
          );
        } else {
          jq(element)
            .closest(domClass.formStepSelector)
            .removeClass(`${errorClass} ${domClass.warningOrange}`);
        }
      },

      success(label) {
        // Only occurs in PPP
        jq(label)
          .closest(domClass.formStepSelector)
          .removeClass(`${domClass.warning} ${domClass.error}`);
      },
    });

    jq.validator.addMethod('verifyUser', () => {
      verifyuser();
      return true;
    });

    jq.validator.addMethod(
      'checkNewUsernamePattern',
      (value, element) => {
        const pattern = usernamePattern;

        if (pattern.test(jq(element).val())) {
          return true;
        }
      },
      T_('Username must be alphanumeric starting with a letter.'),
    );

    jq.validator.addMethod(
      'checkPasswordPattern',
      (value, element) => {
        const val = jq(element).val();

        const nums = val.match(/\d/g);
        const lowers = val.match(/[a-z]/g);
        const uppers = val.match(/[A-Z]/g);
        const pattern = /^.{6,}$/i;

        const patternResult = pattern.test(val);

        if (patternResult) {
          let strengthLevel = 0;
          if (nums) {
            strengthLevel += 2;
          }
          if (lowers) {
            strengthLevel += uppers ? 4 : 3;
          }
          if (uppers) {
            strengthLevel += lowers ? 4 : 3;
          }
          if (strengthLevel > 4) {
            // Occurs only in PPP
            if (typeof isPPP !== 'undefined' && isPPP) {
              updatePasswordHelp(
                {
                  'help-text-num': nums,
                  'help-text-upper': uppers,
                  'help-text-six': patternResult,
                },
                false,
              );
            }
            // Password Valid: Show Success
            jq('#passwd')
              .closest(domClass.formStepSelector)
              .removeClass(domClass.warning)
              .removeClass(domClass.error)
              .addClass(domClass.success);
            return true;
          }
        }

        // Occurs only in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          updatePasswordHelp(
            {
              'help-text-num': nums,
              'help-text-upper': uppers,
              'help-text-six': patternResult,
            },
            true,
          );
        }
      },
      T_('Please enter a stronger password.'),
    );

    jq.validator.addMethod(
      'usernamePasswordEqualCheck',
      (value, element, params) => {
        const $checkElement = jq(params);

        if ($checkElement.length === 0 || $checkElement.val() == '') {
          return true;
        }

        if (value === $checkElement.val()) {
          return false;
        }

        return true;
      },
      T_('Password must not be equal to username'),
    );

    jq('#post-proj-pwd').keypress(e => {
      if (e.which == 13) {
        jq('#nonAuthForm').valid();
      }
    });

    if (signupModalRequired) {
      jq('#normalLoginBtn').click(() => {
        jq('#nonAuthForm').valid();
      });
    }

    jq('#nonAuthForm').bind('validateForm', validateForm);

    const userTypeIdChecked = jq('[name=userType]:checked');
    if (userTypeIdChecked.length > 0) {
      userTypeIdChecked.click();
    }
  });
}

function updatePasswordHelp(params, showHelpBox) {
  jq.each(params, (id, value) => {
    if (value) {
      jq(`#${id}`)
        .removeClass('is-invalid')
        .addClass('is-valid');
    } else {
      jq(`#${id}`)
        .removeClass('is-valid')
        .addClass('is-invalid');
    }
  });

  if (showHelpBox) {
    jq('.password-suggestion-widget')
      .removeClass('is-widget-hidden hide')
      .addClass('is-visible');
    jq('.is-visible').fadeIn(function() {
      jq(this).css('display', '');
    });
  } else {
    setTimeout(() => {
      jq('.password-suggestion-widget')
        .removeClass('is-visible')
        .addClass('is-widget-hidden');
      jq('.is-widget-hidden').fadeOut();
    }, 400);
  }
}

function autofillUsername() {
  usernameSuggester.init();
  const emailInput = jq('#new-email').val();
  let suggestUsername = '';

  usernameSuggester.suggestUsername(emailInput).done(resp => {
    suggestUsername = resp.result.recommended_name;
    // Occurs only in PPP
    if (typeof isPPP !== 'undefined' && isPPP) {
      jq(domClass.formErrorSelector)
        .find(domClass.formErrorText)
        .html('');
    } else {
      jq(domClass.formErrorSelector).html('');
    }
    jq('.username').removeClass('error');
    jq('#new-username').val(suggestUsername);
    jq('#new-username').focus();
  });
}

function verifyNewEmail() {
  jq.ajax({
    dataType: 'json',
    url:
      '/ajax/check-email-exist.php?' +
      `json=true&email=${encodeURIComponent(jq('#new-email').val())}`,
    success(response) {
      if (response.result == 'success') {
        autofillUsername();
        const suggestedEmailId = 'suggested-email';
        jq('#new-email').mailcheck({
          suggested(element, suggestion) {
            jq('#new-email')
              .closest(domClass.formStepSelector)
              .removeClass(domClass.warning)
              .removeClass(domClass.error)
              .addClass(domClass.success);
            const emailSuggestionLink =
              `<a id="${suggestedEmailId}" class="suggestedEmail" href="#">` +
              `${suggestion.address}@${suggestion.domain}</a>`;
            const emailSuggestionText = T_(
              'Did you mean <%=emailSuggestion%> ?',
              {
                emailSuggestion: emailSuggestionLink,
              },
            );
            jq('#new-email')
              .siblings(domClass.formHelpSelector)
              .html(emailSuggestionText);

            // Add Event Listener to User Clicking on the Suggested Email
            document
              .getElementById(suggestedEmailId)
              .addEventListener('click', event => {
                const newEmailEl = document.getElementById('new-email');
                newEmailEl.value = event.srcElement.textContent;
                newEmailEl.focus();
              });
          },
          empty() {
            // Only occurs in PPP
            if (typeof isPPP !== 'undefined' && isPPP) {
              jq('#new-email')
                .closest(domClass.formStepSelector)
                .removeClass(domClass.warning)
                .removeClass(domClass.error);
            } else {
              // Email is Valid. Now also check whether Email is Blocked
              isBlockedEmail(jq('#new-email').val())
                .then(result => {
                  if (result == false) {
                    jq('#new-email')
                      .closest(domClass.formStepSelector)
                      .removeClass(domClass.warning)
                      .removeClass(domClass.error)
                      .addClass(domClass.success);
                    jq('#new-email').trigger('emailValid');
                    return;
                  }
                  jq('#new-email')
                    .closest(domClass.formStepSelector)
                    .removeClass(domClass.success)
                    .removeClass(domClass.warning)
                    .addClass(domClass.error);
                  jq('#new-email')
                    .siblings(domClass.formErrorSelector)
                    .html(
                      T_`This email domain is blocked. Please use a different email address.`,
                    );
                })
                .catch(() => {
                  jq('#new-email').trigger('emailValid');
                });
            }
            jq('#new-email')
              .siblings(domClass.formHelpSelector)
              .html('');
          },
        });
        jq('#new-email').trigger('emailValid');
      } else {
        // Only occurs in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq('#new-email')
            .closest(domClass.formStepSelector)
            .removeClass(domClass.success)
            .addClass(domClass.warningOrange);
        } else {
          jq('#new-email')
            .closest(domClass.formStepSelector)
            .removeClass(domClass.success)
            .addClass(domClass.error);
        }
        // Occurs only in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          if (
            response.msg === 'This email already exists, please choose another'
          ) {
            jq('#new-email')
              .siblings(domClass.formErrorSelector)
              .find(domClass.formErrorText)
              .html(
                T_(
                  "Email already exists. <a id='loginLinkPrefill'>" +
                    'Login instead?</a>',
                ),
              );
          }
        } else {
          jq('#new-email')
            .siblings(domClass.formErrorSelector)
            .html(T_('This email address is already in use.'));
        }
      }
    },
  });
}

function showPrefilledLoginForm() {
  jq('#userTypeReturning').attr('checked', 'true');
  jq('#post-proj-username').val(jq('#new-email').val());
  jq('.authTypeBtn').trigger('click');
  jq('#post-proj-pwd').focus();
}

function verifyNewUsername() {
  jq.ajax({
    dataType: 'json',
    url:
      '/ajax/check-username-exist.php?json=true&' +
      `username=${jq('#new-username').val()}`,
    success(response) {
      const controlGroupDom = jq('#new-username').closest(
        domClass.formStepSelector,
      );
      // Only occurs in PPP
      if (typeof isPPP !== 'undefined' && isPPP) {
        controlGroupDom
          .removeClass(`${domClass.error} ${domClass.warningOrange}`)
          .removeClass(domClass.success);
      } else {
        controlGroupDom
          .removeClass(domClass.error)
          .removeClass(domClass.success);
      }

      if (response.result == 'success') {
        // does not occur in PPP
        if (typeof isPPP === 'undefined' || !isPPP) {
          controlGroupDom.addClass(domClass.success);
        }
        // Occurs only in PPP
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq('#new-username')
            .siblings(domClass.formErrorSelector)
            .find(domClass.formErrorText)
            .html('');
        } else {
          jq('#post-proj-username')
            .siblings(domClass.formErrorSelector)
            .html(T_('Please check your login details.'));
        }
        // Only occurs in PPP
      } else if (typeof isPPP !== 'undefined' && isPPP) {
        controlGroupDom.addClass(domClass.warningOrange);
        jq('#new-username')
          .siblings(domClass.formErrorSelector)
          .find(domClass.formErrorText)
          .html(T_('This username already exists.'));
      } else {
        controlGroupDom.addClass(domClass.error);
        jq('#new-username')
          .siblings(domClass.formErrorSelector)
          .html(T_('This username already exists.'));
      }
    },
  });
}

function getUserDetails() {
  jq(document).ready(() => {
    jq.ajax({
      type: 'get',
      dataType: 'json',
      url: `${sslBaseUrl}/ajax/postproject/userdetails.php`,
      success(response) {
        if (response.status === 'success') {
          if (signupModalRequired) {
            jq('#signup-modal').trigger('initialBid');
            return true;
          }
          isUserReturned = true;
          if (
            response.user_location !== false &&
            typeof window.userLocation !== 'undefined' &&
            window.userLocation === false
          ) {
            window.userLocation = response.user_location;
          }
          const logoHTML =
            `<img src="${response.logo_url}" ` +
            `alt="${response.logoname}" ` +
            'border=0 width=80 height=80 style="margin-right: 20px;">';
          jq('#loggedinLogo').html(logoHTML);
          jq('#loggedinFullname').html(response.name);
          jq('#nonAuthForm').fadeOut('slow', () => {
            jq('#headerTopLoggedIn').fadeIn('slow');
          });
          jq('#createform').removeClass('faded');
        }
      },
    });
  });
}

function verifyuser(callback) {
  clearAuthFormMessages();

  const username = jq('#post-proj-username').val();
  const password = jq('#post-proj-pwd').val();

  if (username == '' || password == '') {
    return false;
  }

  if (!signupModalRequired) {
    jq('#returningForm').hide();
    jq('#returningAjax').show();
  } else {
    jq('#normalLoginBtn').hide();
    jq('#normal-login-spiner').show();
  }
  if (loginAjax) {
    loginAjax.abort();
  }
  loginAjax = jq.ajax({
    type: 'post',
    data: {
      username,
      passwd: password,
      csrf_token: getCSRFToken(),
    },
    dataType: 'json',
    url: `${sslBaseUrl}/ajax/login.php`,
    cache: false,
    success(response) {
      if (jq('#headerTopLoggedIn').is(':visible')) {
        return;
      }

      if (response.status == 'success') {
        if (response.redirect) {
          window.location.href = response.redirect;
        }
        jq('.terms-text, .contest_terms, .hireme-terms').hide();

        if (loginCallback && typeof loginCallback === 'function') {
          isUserReturned = true;
          loginCallback();
        } else {
          getUserDetails();
        }
        if (typeof isPPP !== 'undefined' && isPPP) {
          jq(document).trigger('userLogin', response);
        }
      } else {
        jq('#post-proj-username, #post-proj-pwd')
          .closest(domClass.formStepSelector)
          .removeClass(domClass.success)
          .addClass(domClass.error);
        let errorMsg;
        let errorAnchor;
        if (response.code === 5) {
          errorMsg = response.msg;
          errorAnchor = domClass.authFormAlert;
        } else {
          errorMsg = T_('Please check your login details.');
          errorAnchor = jq('#post-proj-pwd').siblings('.help-inline');
        }

        jq(errorAnchor)
          .html(errorMsg)
          .show();

        if (!signupModalRequired) {
          jq('#returningForm').show();
          jq('#returningAjax').hide();
        } else {
          jq('#normalLoginBtn').show();
          jq('#normal-login-spiner').hide();
        }
      }

      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  });
}

function validateForm() {
  jq(this).data('isValid', jq('#nonAuthForm').valid());
  return jq(this).data('isValid');
}

function userReturned() {
  return isUserReturned;
}

function clearAuthFormMessages() {
  jq('#post-proj-username, #post-proj-pwd')
    .closest(domClass.formStepSelector)
    .removeClass(`${domClass.success} ${domClass.error}`);
  // Occurs only in PPP
  if (typeof isPPP !== 'undefined' && isPPP) {
    jq('#post-proj-username')
      .siblings(domClass.formErrorSelector)
      .find(domClass.formErrorText)
      .html('');
  } else {
    jq('#post-proj-username')
      .siblings(domClass.formErrorSelector)
      .html('');
    jq('#post-proj-pwd')
      .siblings(domClass.formErrorSelector)
      .html('');
  }
  jq(domClass.authFormAlert)
    .html('')
    .hide();
  jq(domClass.authFormError)
    .html('')
    .hide();
}

export default {
  init,
  getUserDetails,
  validateForm,
  userReturned,
  verifyUser: verifyuser,
  isSignUp() {
    return jq('#userTypeNew').is(':checked');
  },
  dom: {
    getForm() {
      return jq('#nonAuthForm');
    },
    isFormVisible() {
      return jq('#nonAuthForm:visible').length > 0;
    },
    getNewEmail() {
      return jq('#new-email');
    },
    getNewUsername() {
      return jq('#new-username');
    },
    getPassword() {
      return jq('#passwd');
    },
    getConfirmPassword() {
      return jq('#passwd1');
    },
  },
};
